import type { ReactNode } from 'react';
import { cx } from './cx';

// Rediseño · Bloque A. Una cifra con su nombre: «Ventas de hoy» + «$12,480». El número es el
// protagonista y la etiqueta lo explica. Solo dibuja: el valor llega ya calculado y ya formateado
// (la verdad del dinero se decide en el servidor, no aquí).
export interface KpiValueProps {
  label: ReactNode;
  /** La cifra, ya formateada. */
  value: ReactNode;
  /** Una línea de contexto bajo la cifra («12 ventas», «vs. $9,300 ayer»). */
  hint?: ReactNode;
  /** `xl` es la cifra protagonista de una pantalla; `lg` una cifra de apoyo; `md` una dentro de una lista. */
  size?: 'md' | 'lg' | 'xl';
  className?: string;
}

// El orden en el HTML —etiqueta, cifra, contexto— es el orden en que se lee en voz alta.
export function KpiValue({ label, value, hint, size = 'md', className }: KpiValueProps) {
  return (
    <div className={cx('n3-kpi', size !== 'md' && `n3-kpi--${size}`, className)}>
      <p className="n3-kpi__label">{label}</p>
      <p className="n3-kpi__value">{value}</p>
      {hint && <p className="n3-kpi__hint">{hint}</p>}
    </div>
  );
}
